module.exports = __webpack_public_path__ + "img/W9.3a69068b.png";